import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = ($target) => {
	const jsControl = $('.js-footer-control');
	const jsFooterContent = $('.js-footer-content');

	function toggleContent(params) {
		event.preventDefault();
		$(this).toggleClass('is-active');
		$(this).parent().next().slideToggle();
	}

	$(jsControl).on('click', toggleContent);

	$(window).on('resize', () => {
		if (MQ('mdUp')) {
			jsFooterContent.each(function () {
				if ($(this).attr('style')) $(this).removeAttr('style');
			});
		}
	});
};
